export const FAILURE_PANEL_TITLE = 'Report validation failed';

export const SUCCESS_PANEL_TITLE = 'Report validated';

export const SUCCESS_READY_MESSAGE = 'Ready to save. The file is uploaded and will be attached when you save.';
